// @flow
import { fetchPatientData } from './patientActions';
import { SERVER_ADDRESS, fetchPost } from '../util/actionsUtil';

export const ADD_IMMUNIZATION_LOADING = 'ADD_IMMUNIZATION_LOADING';
export const ADD_IMMUNIZATION_SUCCESS = 'ADD_IMMUNIZATION_SUCCESS';
export const ADD_IMMUNIZATION_ERROR = 'ADD_IMMUNIZATION_ERROR';
export const UPDATE_IMMUNIZATION_LOADING = 'UPDATE_IMMUNIZATION_LOADING';
export const UPDATE_IMMUNIZATION_SUCCESS = 'UPDATE_IMMUNIZATION_SUCCESS';
export const UPDATE_IMMUNIZATION_ERROR = 'UPDATE_IMMUNIZATION_ERROR';
export const DELETE_IMMUNIZATION_LOADING = 'DELETE_IMMUNIZATION_LOADING';
export const DELETE_IMMUNIZATION_SUCCESS = 'DELETE_IMMUNIZATION_SUCCESS';
export const DELETE_IMMUNIZATION_ERROR = 'DELETE_IMMUNIZATION_ERROR';

export function addAdditionalImmunization(patientId: string, immunization: Object) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/immunization/addAdditionalImmunization`,
      {
        ...immunization,
        patientId,
      },
      (data) => {
        dispatch({
          type: ADD_IMMUNIZATION_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: ADD_IMMUNIZATION_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
    dispatch({
      type: ADD_IMMUNIZATION_LOADING,
    });
  });
}

export function updateAdditionalImmunization(patientId: string, immunization: Object) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/immunization/updateAdditionalImmunization`,
      {
        ...immunization,
        patientId,
      },
      (data) => {
        dispatch({
          type: UPDATE_IMMUNIZATION_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: UPDATE_IMMUNIZATION_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
    dispatch({
      type: UPDATE_IMMUNIZATION_LOADING,
    });
  });
}

export function deleteAdditionalImmunization(patientId: string, immunizationId: string) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/immunization/deleteAdditionalImmunization`,
      {
        immunizationId,
        patientId,
      },
      (data) => {
        dispatch({
          type: DELETE_IMMUNIZATION_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: DELETE_IMMUNIZATION_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
    dispatch({
      type: DELETE_IMMUNIZATION_LOADING,
    });
  });
}

export function updateRequiredImmunization(patientId: string, immunization: Object) {
  return ((dispatch: Function) => {
    fetchPost(
      `${SERVER_ADDRESS}/immunization/updateRequiredImmunization`,
      {
        ...immunization,
        patientId,
      },
      (data) => {
        dispatch({
          type: UPDATE_IMMUNIZATION_SUCCESS,
          data,
        });
        dispatch(fetchPatientData(patientId));
      },
      (error) => {
        dispatch({
          type: UPDATE_IMMUNIZATION_ERROR,
          error: error.message || error.toString(),
        });
      },
    );
    dispatch({
      type: UPDATE_IMMUNIZATION_LOADING,
    });
  });
}



// WEBPACK FOOTER //
// ./client/src/actions/immunizationActions.js